module.exports = __webpack_public_path__ + "img/logo.38ce3555.png";